const USB_DAC_NAMES_KEY = 'maestro_usb_dac_names';
const SELECTED_USB_DAC_KEY = 'maestro_selected_usb_dac';

export type SelectedUsbDac = { id: string; name: string; uid?: string };

export function readSelectedUsbDac(): SelectedUsbDac | null {
  try {
    const raw = localStorage.getItem(SELECTED_USB_DAC_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SelectedUsbDac;
    if (parsed?.id && parsed?.name) return parsed;
  } catch { /* ignore */ }
  return null;
}

export function writeSelectedUsbDac(dac: SelectedUsbDac | null): void {
  try {
    if (!dac) localStorage.removeItem(SELECTED_USB_DAC_KEY);
    else localStorage.setItem(SELECTED_USB_DAC_KEY, JSON.stringify(dac));
  } catch { /* ignore */ }
}

export function readUsbDacNames(): Record<string, string> {
  try { return JSON.parse(localStorage.getItem(USB_DAC_NAMES_KEY) || '{}'); } catch { return {}; }
}

export function writeUsbDacName(uid: string, name: string): void {
  const all = readUsbDacNames();
  all[uid] = name;
  localStorage.setItem(USB_DAC_NAMES_KEY, JSON.stringify(all));
}

export function getUsbDacDisplayName(device: { uid?: string; name: string }): string {
  if (device.uid) {
    const saved = readUsbDacNames()[device.uid];
    if (saved) return saved;
  }
  return device.name;
}

const USB_DAC_PROFILES_KEY = 'maestro_usb_dac_profiles';

export function isExclusiveModeEnabled(uid: string | undefined): boolean {
  if (!uid) return false;
  try {
    const profiles = JSON.parse(localStorage.getItem(USB_DAC_PROFILES_KEY) || '{}');
    const profile = profiles[uid];
    if (!profile) return true; // default ON for USB DACs with no profile yet
    return profile.exclusive_mode !== false;
  } catch {
    return false;
  }
}

/** Exclusive gate for a resolved USB DAC — Windows uses cpal device id when uid is empty. */
export function isExclusiveModeEnabledForDevice(dac: SelectedUsbDac | null | undefined): boolean {
  if (!dac?.id && !dac?.uid) return false;
  if (dac.uid) return isExclusiveModeEnabled(dac.uid);
  return true;
}
